import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import type { ChatSpeechTokenResponse, ChatStreamMessagesRequest } from "../ea.types";

const base = "chats";
const chats = createEndpointBase(base);
const documents = createEndpointBase(base, ":fileId", "documents");

export const chatsEndpoints = {
  chatsCreateSpeechToken: chats({
    method: "GET",
    path: "speech-token",
    request: z.any(),
    response: z.any(),
    requestType: {} as unknown as void,
    responseType: {} as ChatSpeechTokenResponse,
    description: "Creates a speech token for AI voice interactions.",
  }),
  chatsStreamMessages: chats({
    method: "POST",
    path: "stream-messages",
    request: z.any(),
    response: z.any(),
    requestType: {} as ChatStreamMessagesRequest,
    responseType: {} as any,
    description: "Streams AI chat messages and handles tool calls.",
  }),

  chatsDocumentsCreate: documents({
    method: "POST",
    path: ":fileType",
    request: z.any(),
    response: z.any(),
    requestType: {} as any,
    responseType: {} as unknown as void,
    description: "Uploads and indexes a document for AI chat context.",
  }),
  chatsDocumentsDelete: documents({
    method: "DELETE",
    path: "",
    request: z.any(),
    response: z.any(),
    requestType: {} as any,
    responseType: {} as unknown as void,
    description: "Deletes an indexed document from the AI chat context.",
  }),
  chatsQueryDocuments: chats({
    method: "POST",
    path: "query-documents",
    request: z.any(),
    response: z.any(),
    requestType: {} as { question: string; fileId?: string },
    responseType: {} as { chunks: string[] },
    description: "Searches indexed documents using semantic similarity.",
  }),
} as const;
